//TextField personalizzato per input dati

import React from 'react';
import { TextField } from '@material-ui/core';


export default function Input(props) {

  const {required, variant, label, value, className, onChange, name} = props;
  //console.log(props);

    return (
      <>
        <TextField
          required = {required}
          variant = {variant}
          label = {label}
          value = {value}
          className = {className}
          onChange = {onChange}
          name = {name}
          //error
          //helperText = "pippone"
        />
      </>
    )
}
